import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { ReactionBar, ReactionSummary } from "@/components/Reactions";
import { RepostButton } from "@/components/Repost";
import { Comments } from "@/components/Comments";

const BASE = { fact: "facts", live: "live" };
const FIELD = { fact: "shared_fact_id", live: "shared_live_id" };

// React, comment and repost on a checked Fact or a Middle Live issue.
// inline: the comment button opens comments right under the card (feed); otherwise it opens the Fact page's comments.
export const FactActions = ({ f, kind = "fact", inline = false, onComments, onOpenChange, commentCount, className = "" }) => {
  const nav = useNavigate();
  const [item, setItemState] = useState(f);
  const setItem = (fn) => { setItemState(fn); if (kind === "fact") window.dispatchEvent(new Event("middle:fact-activity")); };
  const [open, setOpenState] = useState(false);
  const setOpen = (fn) => setOpenState((o) => { const v = typeof fn === "function" ? fn(o) : fn; onOpenChange?.(v); return v; });
  // A poll brings fresh counts: take them, keep your own reaction/repost as you just set them.
  useEffect(() => { setItemState((x) => ({ ...x, reaction_count: f.reaction_count, reaction_counts: f.reaction_counts, comment_count: f.comment_count, share_count: f.share_count })); },
    [f.reaction_count, f.comment_count, f.share_count, JSON.stringify(f.reaction_counts || {})]); // eslint-disable-line react-hooks/exhaustive-deps
  const base = `/${BASE[kind]}/${f.id}`;
  const stop = (e) => { e.stopPropagation(); if (e.currentTarget.contains(e.target)) e.preventDefault(); };
  const comments = commentCount ?? item.comment_count ?? 0;
  const openComments = () => (onComments ? onComments() : inline ? setOpen((o) => !o) : nav(`${base}#comments`));
  const tid = kind === "fact" ? `fact-${f.id}` : `live-${f.id}`;
  return (
    <div onClick={onComments ? undefined : stop} className={className}>
      {kind !== "live" && <ReactionSummary item={item} testid={`${kind}-react-${f.id}`} className="px-1 pb-1 pt-1" />}
      <div className="flex flex-wrap items-center gap-1 text-sm text-slate-500" data-testid={`${kind}-actions-${f.id}`}>
        {kind !== "live" && <ReactionBar item={item} setItem={setItem} url={`${base}/react`} whoUrl={`${base}/reactions`} testid={`${kind}-react-${f.id}`} />}
        <button type="button" data-testid={`${kind}-comment-btn-${f.id}`} onClick={openComments}
          className="flex items-center gap-1.5 rounded-full px-3 py-1.5 transition-colors hover:bg-black/5"><MessageSquare size={17} strokeWidth={1.8} />{comments}</button>
        <RepostButton item={item} setItem={setItem} field={FIELD[kind]} testid={`${kind}-repost-${f.id}`} />
      </div>
      {inline && open && <Comments base={base} id={tid} onCount={(n) => setItem((x) => ({ ...x, comment_count: Math.max(0, (x.comment_count || 0) + n) }))} />}
    </div>
  );
};
